import React, { useEffect, useState } from 'react';
import { useTemperaturesWinds } from '../../services/temperaturesWinds/temperaturesWinds';
import { Marker, useMapEvents } from 'react-leaflet';
import './Temperatures.css'

export const Temperatures = () => {
    const temperaturesWinds = useTemperaturesWinds();
    const [ temperatures, setTemperatures ] = useState<any>([]);
    const [ reload, setReload ] = useState<any>(false);
    
    useMapEvents({
        zoom: (event) => {
            setReload(!reload);
        },
        move: (event) => {
            setReload(!reload);
        }
    })

    const init =  () => {
        if (temperaturesWinds) {
            const data = temperaturesWinds.getTemperatures();
            setTemperatures(data);
        }
    }
    

    useEffect(() => {
        init();
    }, [temperaturesWinds,reload]);

    return (
        <>
            {temperatures.map((element: any, index: number) => (
                element && (
                    <div key={index} className="map-element">
                        <Marker 
                            position={element.position} 
                            icon={element.mainIcon}
                            pane="overlayMarkersPane"
                        />
                        <Marker 
                            position={element.position} 
                            icon={element.borderIcon}
                            pane="alertMarkersPane"
                        />
                    </div>
                )
            ))}
        </>
    );
};